import { startPage } from '../main';
import { icons } from '../lib/icons';

startPage();

document.querySelectorAll('[data-icon]').forEach((el) => { el.innerHTML = icons[el.dataset.icon](); });

// Feature carousel: one slide at a time, with dots, arrows and a slow autoplay that stops on interaction.
const track = document.getElementById('feature-track');
const slides = [...track.querySelectorAll('.feature-slide')];
const dots = document.getElementById('feature-dots');
let current = 0;

slides.forEach((slide, index) => {
  const dot = document.createElement('button');
  dot.type = 'button';
  dot.className = 'h-3 w-3 rounded-full bg-blue/30 transition aria-[current=true]:bg-pink';
  dot.setAttribute('aria-label', `Show feature ${index + 1}`);
  dot.addEventListener('click', () => { stop(); show(index); });
  dots.append(dot);
});

function show(index) {
  current = (index + slides.length) % slides.length;
  track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
}

track.addEventListener('scroll', () => {
  const index = Math.round(track.scrollLeft / track.clientWidth);
  if (index !== current) {
    current = index;
    [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
  }
}, { passive: true });

let timer = null;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!reducedMotion) timer = setInterval(() => show(current + 1), 6000);
function stop() { clearInterval(timer); }

document.getElementById('feature-prev').addEventListener('click', () => { stop(); show(current - 1); });
document.getElementById('feature-next').addEventListener('click', () => { stop(); show(current + 1); });
track.addEventListener('pointerdown', stop);
show(0);

// The animations are loaded only when the features come into view.
const observer = new IntersectionObserver(async (entries) => {
  if (!entries.some((entry) => entry.isIntersecting)) return;
  observer.disconnect();
  const { default: lottie } = await import('lottie-web/build/player/lottie_light');
  document.querySelectorAll('[data-animation]').forEach((container) => {
    lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: true,
      autoplay: !reducedMotion,
      path: `/json/${container.dataset.animation}.json`,
    });
  });
}, { rootMargin: '200px' });
observer.observe(track);
